import axios from 'axios'
import ChallengeModel from '@/services/Models/ChallengeModel'

export default {
  getChallenges(params) {
    return axios.get('/challenges', { params })
      .then(mapToChallenge)
  },

  getChallenge(id) {
    return axios.get('/challenges/' + id)
      .then(mapToChallenge)
  }
}

function mapToChallenge(response) {
  const data = response.data

  if (data instanceof Array) {
    return data.map(ChallengeModel)
  }

  return ChallengeModel(data)
}



// WEBPACK FOOTER //
// ./src/services/Api/ChallengeApi.js